import { useEffect, useState } from "react";
import { FaDownload, FaFileAlt, FaPlus, FaShareSquare, FaUpload } from "react-icons/fa";
import { Button, LoadingIcon } from "@prosolve/common-components-ui";
import { checkHasEditEventPermissions, downloadUrls, getClientSubdomain } from "../../../../utils";
import EventResourcesModal from "./EventResourcesModal";
import { resToArray } from "./EventResourcesEditor";
import useDataResourceFiles from "../../../../dataHooks/useDataResourceFiles";
import UploadResourceFilesModal from "./UploadResourceFilesModal";

export default ({
  eventData: defaultEventData
}) => {
  const [eventData, setEventData] = useState(defaultEventData)
  const [resourcesModal, setResourcesModal] = useState()
  const [isUploadResourceFilesModalOpen, setIsUploadResourceFilesModalOpen] = useState(false)
  const [isResourceFilesLoading, setIsResourceFilesLoading] = useState(false)
  const [resourceFiles, setResourceFiles] = useState([])

  const clientSubdomain = getClientSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')

  const {
    id: eventId,
    blueprintResources,
    resources
  } = eventData

  const hasEditPermissions = checkHasEditEventPermissions();
  const { fetchResourceFiles } = useDataResourceFiles();

  const blueprintResourcesArr = resToArray(blueprintResources)
  const resourcesArr = resToArray(resources)

  const getResourceFiles = async (eventId) => {
    setIsResourceFilesLoading(true)
    try {
      const filesData = await fetchResourceFiles(eventId);
      setResourceFiles(filesData)
    } catch (e) {
      setResourceFiles([])
    }
    setIsResourceFilesLoading(false)
  }

  useEffect(() => {
    if (eventId) {
      getResourceFiles(eventId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  const onSuccess = (eventData) => {
    setEventData(eventData)
    setResourcesModal()
  } 

  const onUploadResourceFilesSuccess = async () => {
    setIsUploadResourceFilesModalOpen(false)
    getResourceFiles(eventId)
  }

  const onClickEventResource = async (file) => {
    await downloadUrls([{ url: file?.url, filename: file?.name }])
  }

  const onClickDownloadAllEventFiles = async () => {
    await downloadUrls(resourceFiles.map(r => ({ url: r?.url, filename: r?.name })), 'EventFiles.zip')
  }

  return (
    <div style={{ padding: '20px' }}>
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}>
        <div style={{
          flex: 1,
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          marginLeft: '20px'
        }}>
          {`Template Resources`}
        </div>
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        padding: '20px',
        gap: '15px',
        justifyContent: 'left',
      }}>
        {
          blueprintResourcesArr?.length === 0
          ?
          <div>
            No resources have been added
          </div>
          :
          blueprintResourcesArr?.map((resource, index) => {
            return (
              <div 
                key={`${resource?.[0]}-${index}`} 
                style={{ 
                  color: 'rgb(2, 128, 198)',
                  display: 'flex',
                  gap: '5px'
                }}
              >
                <FaShareSquare />
                <a 
                  href={resource?.[1]} 
                  target="_blank" 
                  rel="noreferrer"
                  style={{ 
                    color: 'rgb(2, 128, 198)'
                  }}
                >
                  {resource?.[0]}
                </a>
              </div>
            )
          })
        }
      </div>

      <div style={{ paddingBottom: '20px' }}></div>

      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}>
        <div style={{
          flex: 1,
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          marginLeft: '20px'
        }}>
          {`Event Resources`}
        </div>
        {hasEditPermissions &&
          <Button
            style={{
              display: 'inline-flex',
              padding: '8px 16px',
              marginRight: '20px'
            }}
            onClick={() => setResourcesModal(true)}
          >
            <FaPlus style={{ marginRight: '10px', color: '#0280c6' }} />
            <span style={{ fontWeight: 'bold', color: '#565656'}}>{'Edit Resources'}</span>
          </Button>
        }
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        padding: '20px',
        gap: '15px',
        justifyContent: 'left',
      }}>
        {
          resourcesArr?.length === 0
          ?
          <div>
            No resources have been added
          </div>
          :
          resourcesArr?.map((resource, index) => {
            return (
              <div 
                key={`${resource?.[0]}-${index}`} 
                style={{ 
                  color: 'rgb(2, 128, 198)',
                  display: 'flex',
                  gap: '5px'
                }}
              >
                <FaShareSquare />
                <a 
                  href={resource?.[1]} 
                  target="_blank" 
                  rel="noreferrer"
                  style={{ 
                    color: 'rgb(2, 128, 198)'
                  }}
                >
                  {resource?.[0] || '-'}
                </a>
              </div>
            )
          })
        }
      </div>

      <div style={{ paddingBottom: '20px' }}></div>

      {!isStarSubdomain &&
      <>
        <div style={{
          display: 'flex',
          alignItems: 'center'
        }}>
          <div style={{
            flex: 1,
            color: '#565656',
            fontSize: '24px',
            fontWeight: 'bold',
            marginLeft: '20px'
          }}>
            {`Event Files`}
          </div>
          <Button
            style={{
              display: 'inline-flex',
              padding: '8px 16px',
              marginRight: '20px'
            }}
            onClick={() => onClickDownloadAllEventFiles(true)}
          >
            <FaDownload style={{ marginRight: '10px', color: '#0280c6' }} />
            <span style={{ fontWeight: 'bold', color: '#565656'}}>{'Download All Files'}</span>
          </Button>
          {hasEditPermissions &&
            <Button
              style={{
                display: 'inline-flex',
                padding: '8px 16px',
                marginRight: '20px'
              }}
              onClick={() => setIsUploadResourceFilesModalOpen(true)}
            >
              <FaUpload style={{ marginRight: '10px', color: '#0280c6' }} />
              <span style={{ fontWeight: 'bold', color: '#565656'}}>{'Upload Files'}</span>
            </Button>
          }
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          flexWrap: 'wrap',
          padding: '20px',
          gap: '15px',
          justifyContent: 'left',
        }}>
          {
            isResourceFilesLoading
            ?
            <LoadingIcon />
            :
            resourceFiles?.length === 0
            ?
            <div>
              No resource files have been added
            </div>
            :
            resourceFiles?.map((file, index) => {
              return (
                <div 
                  key={`${file?.url}-${index}`} 
                  style={{ 
                    color: 'rgb(2, 128, 198)',
                    display: 'flex',
                    gap: '5px'
                  }}
                >
                  <FaFileAlt />
                  <div 
                    style={{ 
                      color: 'rgb(2, 128, 198)',
                      cursor: 'pointer'
                    }}
                    onClick={() => onClickEventResource(file)}
                  >
                    {file?.name || '-'}
                  </div>
                </div>
              )
            })
          }
        </div>
      </>
      }

      {resourcesModal &&
        <EventResourcesModal eventData={eventData} onClose={() => setResourcesModal()} onSuccess={onSuccess} />
      }
      {isUploadResourceFilesModalOpen &&
        <UploadResourceFilesModal 
          eventId={eventId}
          onClose={() => setIsUploadResourceFilesModalOpen(false)}
          onSuccess={onUploadResourceFilesSuccess}
        />
      }
    </div>
  )
}